"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetToJSON = exports.DatasetFromJSONTyped = exports.DatasetFromJSON = exports.instanceOfDataset = void 0;
var runtime_1 = require("../runtime");
var CapiIntegration_1 = require("./CapiIntegration");
var Pixel2_1 = require("./Pixel2");
var SharedAdAccount_1 = require("./SharedAdAccount");
/**
 * Check if a given object implements the Dataset interface.
 */
function instanceOfDataset(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDataset = instanceOfDataset;
function DatasetFromJSON(json) {
    return DatasetFromJSONTyped(json, false);
}
exports.DatasetFromJSON = DatasetFromJSON;
function DatasetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'pixel': !(0, runtime_1.exists)(json, 'pixel') ? undefined : (0, Pixel2_1.Pixel2FromJSON)(json['pixel']),
        'capiIntegration': !(0, runtime_1.exists)(json, 'capi_integration') ? undefined : (0, CapiIntegration_1.CapiIntegrationFromJSON)(json['capi_integration']),
        'adSetCount': !(0, runtime_1.exists)(json, 'ad_set_count') ? undefined : json['ad_set_count'],
        'isArchived': !(0, runtime_1.exists)(json, 'is_archived') ? undefined : json['is_archived'],
        'isReceivingEvents': !(0, runtime_1.exists)(json, 'is_receiving_events') ? undefined : json['is_receiving_events'],
        'sharedAdAccounts': !(0, runtime_1.exists)(json, 'shared_ad_accounts') ? undefined : (json['shared_ad_accounts'].map(SharedAdAccount_1.SharedAdAccountFromJSON)),
    };
}
exports.DatasetFromJSONTyped = DatasetFromJSONTyped;
function DatasetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'pixel': (0, Pixel2_1.Pixel2ToJSON)(value.pixel),
        'capi_integration': (0, CapiIntegration_1.CapiIntegrationToJSON)(value.capiIntegration),
        'ad_set_count': value.adSetCount,
        'is_archived': value.isArchived,
        'is_receiving_events': value.isReceivingEvents,
        'shared_ad_accounts': value.sharedAdAccounts === undefined ? undefined : (value.sharedAdAccounts.map(SharedAdAccount_1.SharedAdAccountToJSON)),
    };
}
exports.DatasetToJSON = DatasetToJSON;
